/* eslint-disable prettier/prettier */
/* eslint-disable no-console */

import request from '@/utils/request'
import qs from 'qs'
// 检测绩效统计
export const queryPerfWorkload = (data) => {
  return request({
    url: '/workload/queryPerfWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

// 检查绩效统计
export const queryInspectPerfWorkload = (data) => {
  return request({
    url: '/workload/queryInspectPerfWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

// 总绩效统计
export const queryTotalPerfWorkload = (data) => {
  return request({
    url: '/workload/queryTotalPerfWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

// 确认绩效：将绩效值、绩效等级同步到工资明细表
export const confirmPerf = (data) => {
  return request({
    url: '/workload/confirmPerf',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

// 总绩效统计导出（与列表数据一致）
export const exportTotalPerfWorkload = (data) => {
  return request({
    url: '/workload/exportTotalPerfWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(data),
    responseType: 'blob'
  })
}

// 工作量统计
export const checkWorkload = (data) => {
  return request({
    url: '/workload/checkWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

//工作量统计导出下载
export const workloadExport = (postData) => {
  return request({
    url: '/workload/exportMonthlyWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}

//设备类型查看（字典）
export const queryDict = (data) => {
  return request({
    url: '/weight/queryDict',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
// 权重查看
export const pageWeight = (data) => {
  return request({
    url: '/weight/pageWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重修改
export const updateWeight = (data) => {
  return request({
    url: '/weight/updateWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重删除
export const deleteWeight = (data) => {
  return request({
    url: '/weight/deleteWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重添加
export const saveWeight = (data) => {
  return request({
    url: '/weight/saveWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
